import React, { useEffect } from "react";
import app from "nystem";

export default ({ imageRef, imgSrc, setRetry, ...props }) => {
  useEffect(() => {
    const onConnection = ({ connected }) => connected && imgSrc === "error" && setRetry((retry) => retry + 1);
    app.connection.on("connection", onConnection); return () => app.connection.off("connection", onConnection);
  }, [imageRef, imgSrc, setRetry]);
  return React.createElement("div", { ...props, ref: imageRef });
};
